import axios from 'axios'
import store from '@/store'
import router from '@/router'

function resolveBase () {
  const raw = process.env.VUE_APP_RUTA_API_RH || ''
  if (!raw) return ''
  return raw.endsWith('/') ? raw : `${raw}/`
}

const http = axios.create({
  baseURL: resolveBase(),
  timeout: 120000,
})

http.interceptors.request.use((config) => {
  const url = String((config.url || '') + (config.baseURL || ''))
  const isLogin = url.indexOf('usuarios.data') !== -1
  if (isLogin) {
    delete config.headers.Authorization
    return config
  }

  const token = store.state.loginVendedora && store.state.loginVendedora.accessToken
  const perfil = store.state.loginVendedora && store.state.loginVendedora.perfil
  const iderp = perfil && (
    perfil.iderp != null ? perfil.iderp
      : (perfil.id_usuario != null ? perfil.id_usuario : perfil.idusuario)
  )

  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  if (iderp != null && String(iderp).trim() !== '') {
    const id = String(iderp)
    config.headers['user-id'] = id
    config.headers['id-usuario'] = id
    config.headers['user-iD'] = id
  }
  return config
})

http.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response && err.response.status
    const url = String((err.config && err.config.url) || '')
    if (status === 401 && url.indexOf('usuarios.data') === -1) {
      store.dispatch('loginVendedora/salir')
      const path = router.currentRoute && router.currentRoute.path
      if (path && String(path).startsWith('/vendedora')) {
        router.replace({ name: 'Login' })
      }
    }
    return Promise.reject(err)
  }
)

export default http
